import { isPortal } from './helpers.js'

export default [
  {
    path: isPortal() ? '/:trackingCode' : '/track/:trackingCode',
    component: () => import(/* webpackChunkName: "track" */ '@/layouts/Tracking.vue'),
    children: [
      {
        path: isPortal() ? '' : 'status',
        name: 'TrackingLinkStatus',
        component: () => import(/* webpackChunkName: "track" */ '@/views/track/OrderStatus.vue')
      },
      {
        path: 'track',
        name: 'TrackingLinkTrackDriver',
        component: () => import(/* webpackChunkName: "track" */ '@/views/track/TrackDriver.vue')
      },
      {
        path: 'update-address',
        name: 'TrackingLinkUpdateAddress',
        component: () => import(/* webpackChunkName: "track" */ '@/views/track/UpdateAddress.vue')
      },
      {
        path: 'feedback',
        name: 'TrackingLinkSendFeedback',
        component: () => import(/* webpackChunkName: "track" */ '@/views/track/SendFeedback.vue')
      }
    ]
  }
]